<template>
  <TeachersEditTabAccount />
</template>

<script>
import { onUnmounted, provide, ref } from '@vue/composition-api'
import TeachersEditTabAccount from './TeachersEditTabAccount'
import teacherModule from '../teacherModule'
import router from '@/router'
import store from '@/store'
import { getGroups } from '@/composables/groupService'
export default {
    components: { TeachersEditTabAccount },
    setup(){
        const TEACHERS_MODULE = 'teachers'
        const groups = ref([])
        const teacher = ref([])

        provide('teacher', teacher)
        provide('groups', groups)

        if(!store.hasModule(TEACHERS_MODULE)) store.registerModule(TEACHERS_MODULE, teacherModule)

        onUnmounted(() => {
            if(store.hasModule(TEACHERS_MODULE)) store.unregisterModule(TEACHERS_MODULE)
        })

        store.dispatch('teachers/fetchTeacher', { id: router.currentRoute.params.id }).then(response => { 
            teacher.value = response.data.teacher
        })

        const fetchGroups = async function () { groups.value = (await getGroups()).data.groups }
        fetchGroups()


        return {

        }
    }
}
</script>